import React from "react";
import { usePortalTheme, PortalThemeButton } from "@/components/PortalTheme";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Brand } from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { LayoutDashboard, Building2, Settings, LogOut } from "lucide-react";

const links = [
  { to: "/admin", end: true, label: "Panel", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/admin/firmalar", label: "Firmalar", icon: Building2, testid: "nav-companies" },
  { to: "/admin/ayarlar", label: "E-posta Ayarları", icon: Settings, testid: "nav-settings" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const { mode, toggle } = usePortalTheme();
  const doLogout = async () => { await logout(); nav("/login", { replace: true }); };

  return (
    <div className="min-h-screen" style={{ backgroundColor: mode === "night" ? "#202124" : "#ffffff" }}>
      <header className="sticky top-0 z-30 border-b border-slate-200 bg-white/90 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
          <Brand />
          <div className="flex items-center gap-3">
            <span className="hidden text-right sm:block">
              <span className="block text-sm font-semibold text-[#0a192f]">{user?.name}</span>
              <span className="block text-xs text-slate-500">Yönetici</span>
            </span>
            <PortalThemeButton mode={mode} toggle={toggle} />
            <Button variant="outline" size="sm" onClick={doLogout} data-testid="logout-button">
              <LogOut className="h-4 w-4 sm:mr-2" /><span className="hidden sm:inline">Çıkış</span>
            </Button>
          </div>
        </div>
        <nav className="mx-auto flex max-w-7xl gap-1 overflow-x-auto px-4 sm:px-6 lg:px-8">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={l.testid}
              className={({ isActive }) =>
                `flex items-center gap-2 border-b-2 px-3 py-3 text-sm font-medium whitespace-nowrap transition-colors ${
                  isActive ? "border-emerald-600 text-emerald-700" : "border-transparent text-slate-500 hover:text-slate-800"
                }`}>
              <l.icon className="h-4 w-4" /> {l.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8"><Outlet /></main>
    </div>
  );
}
